import { diInject } from "stores/diContext";
import { requiredStringOrArray, required, isEmail } from "./_validator";
import { nextId } from "utils/id";
import { EventStore } from "../stores/events";
import { OrderStore } from "../stores/order";
import { FieldState, FormState } from 'formstate/src';
import { observable, action, toJS } from 'mobx';
import { QuestionState } from "Apps/ticketing/forms/question";
import * as _ from "lodash";
import { number } from "prop-types";


export class AttendeeState {
    @diInject() eventStore: EventStore;
    constructor(public key, public ticket) {

        const { event: {
            is_set_addtional_info,
            skip_collect_attendee_information,
            need_collect_demographic_data,
            need_collect_full_birth_day,
            need_collect_phone_number
        } } = this.eventStore;

         if (is_set_addtional_info) {
            const { event: { questions } } = this.eventStore;
            const ticket_questions = questions.filter(q => q.applied_to_ticket_id.includes(ticket.id) && q.ask_to == "Attendee");

            for (let q of ticket_questions) {
                const key = `${q.id}`;
                var qState = new QuestionState(q)
                this.question_answers.set(key, qState);
            }
         }
        if (!skip_collect_attendee_information || need_collect_demographic_data) {
            this.first_name.validators(required());
            this.last_name.validators(required());
            this.email_address.validators(required(), isEmail());
            if (need_collect_phone_number) {
                this.phone_number.validators(required());
            }
        }
        if (need_collect_demographic_data) {
            this.birth_month.validators(required());
            this.birth_day.validators(required());
        }
        if (need_collect_demographic_data && need_collect_full_birth_day) {
            this.birth_year.validators(required());
        }
    }

    ticket_id = this.ticket.id;
    ticket_name = this.ticket.name;
    first_name = new FieldState("");
    last_name = new FieldState("");
    email_address = new FieldState("");
    phone_number = new FieldState("");
    birth_month = new FieldState(1);
    birth_year = new FieldState("");
    birth_day = new FieldState("");
    question_answers = observable.map<QuestionState>({});
    questions() {
        var fields = this.question_answers.values();
        //对问题排序
        fields.sort((a, b) => {
            return a.question.placement_index - b.question.placement_index;
        });
        return fields;
    }
    formState = new FormState({
        first_name: this.first_name,
        last_name: this.last_name,
        email_address: this.email_address,
        phone_number: this.phone_number,
        birth_day: this.birth_day,
        birth_month: this.birth_month,
        birth_year: this.birth_year,
    });
    async validate() {
        var hasError = false;
        var task1 = this.formState.validate();
        var tasks = [task1];
        var questions = this.question_answers.values();
        for (var q of questions) {
            var task = q.validate();
            tasks.push(task);
        }
        var results = await Promise.all(tasks);
        hasError = results.find(r => r.hasError) != null;
        return { hasError };
    }

}

export default class AttendeesForm {

    @diInject() eventStore: EventStore;
    @diInject() orderStore: OrderStore;
    attendees = observable.map<AttendeeState>({});
    getCurrentFields() {
        return this.attendees.values();
        
    }
    add(ticket) {
        const { id: ticket_id, name: ticket_name } = ticket;
        const { event, event: { skip_collect_attendee_information, need_collect_demographic_data } } = this.eventStore;

        var key = `${ticket_id}-${nextId()}`;
        var attendee = new AttendeeState(key, ticket);
        if (attendee.questions().length > 0 || !skip_collect_attendee_information || need_collect_demographic_data) {
            this.attendees.set(key, new AttendeeState(key, ticket));
        }
    }

    remove(ticket_id) {
        const { event: { skip_collect_attendee_information } } = this.eventStore;
        var item = _.findLast(this.attendees.values(), (attendee) => {
            return attendee.ticket_id == ticket_id
        })
        if (item && this.attendees.has(item.key)) {
            this.attendees.delete(item.key)
        }
    }

    removeAll() {
        this.attendees.clear();
    }

    setFirstAttendeeInfo() {
        const first_attendee = this.attendees.values()[0];
        const copy_fields = ["first_name", "last_name", "email_address", "phone_number", "birth_year", "birth_month", "birth_day"];
        for (let key of copy_fields) {
            if (first_attendee[key].$ != "") {
                return;
            }
        }
        const puchaser = this.orderStore.purchaser.values();
        for (let key of copy_fields) {
            var purchaser_key = `customer_${key}`;
            first_attendee[key].onChange(puchaser[purchaser_key]);
        }
    }


    get(ticket_id) {
        var attendees = this.attendees.values().filter(item => {
            return item.ticket_id == ticket_id
        });
        return attendees.map(item => {
            const { first_name, last_name, email_address, phone_number, birth_year, birth_month, birth_day } = item;
            return {
                first_name: first_name.$,
                last_name: last_name.$,
                email_address: email_address.$,
                phone_number: phone_number.$,
                birth_year: birth_year.$,
                birth_month: birth_month.$,
                birth_day: birth_day.$,
                question_answers: item.questions().map((qa) => {
                    var answers = toJS(qa.answers.$);
                    return {
                        id: qa.id,
                        answers: _.isArray(answers) ? answers : [answers]
                    }
                })
            }
        })
    }
    async validate() {
        var attendees = this.attendees.values();
        var hasError = false;
        var tasks = [];
        for (var a of attendees) {
            var task = a.validate();
            tasks.push(task);
        }
        var results = await Promise.all(tasks);
        hasError = results.find(r => r.hasError) != null;
        return { hasError };
    }
    static create() {
        return new AttendeesForm();
    }
}



// WEBPACK FOOTER //
// ./src/Apps/ticketing/forms/attendees.ts